export enum PrescriptionStatus  {
    SAVED = 'SAVED',
    SENT = 'SENT',
    NO_PRESCRIPTION = 'NO_PRESCRIPTION',
    CANCELED = 'CANCELED',
    RESENT = 'RESENT'
}